// extracted by mini-css-extract-plugin
export var contentWrapper = "style-module--contentWrapper--d28a2";
export var details = "style-module--details--caa02";
export var image = "style-module--image--c864e";
export var productContent = "style-module--productContent--27194";